import { WriteHook, useMutationManager } from 'react-query-state-manager'

import { saveRFIApplication } from 'commons/service/client/application'
import { OnboardingRFIFormSavePayload } from 'commons/types/DTO/commons/webpagesOnboardinForm'
import { PortalName } from 'commons/types/enums'

export const useUpdateApplication: WriteHook<{ application: OnboardingRFIFormSavePayload; p: PortalName }, unknown> = (
  opts
) => useMutationManager<{ application: OnboardingRFIFormSavePayload; p: PortalName }, unknown>(saveRFIApplication, opts)
